"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
function equal(x, y) {
    return x.id === y.id;
}
exports.equal = equal;
function include(items, _a) {
    var id = _a.id;
    return !!_.find(items, { id: id });
}
exports.include = include;
function addItemToItems(items, item) {
    return __spread([item], (removeItemFromItems(items, item.id)));
}
exports.addItemToItems = addItemToItems;
function removeItemFromItems(items, id) {
    items = __spread(items);
    _.remove(items, { id: id });
    return items;
}
exports.removeItemFromItems = removeItemFromItems;
//# sourceMappingURL=item.js.map


//////////////////
// WEBPACK FOOTER
// ./local_modules/common/domain/item.js
// module id = 88
// module chunks = 0